import apiSlice from "./ApiSlice";

const ExpenseCategoriesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllExpenseCategoriesData: builder.query({
      providesTags: ["expense-categories"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/expense-category",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteExpenseCategoriesById: builder.mutation({
      invalidatesTags: ["expense-categories"],
      query: (id: any) => ({
        url: `/expense-category/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addExpenseCategories: builder.mutation({
      invalidatesTags: ["expense-categories"],
      query: (body) => ({
        url: `/expense-category/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getExpenseCategoriesById: builder.query({
      providesTags: ["expense-categories"],
      query: (id: string) => {
        return {
          url: `/expense-category/${id}`,
          method: "GET",
        };
      },
    }),


    //get Payment Modes
    getAllExpenseCategories: builder.query({
      providesTags: ["expense-categories"],
      query: () => {
        return {
          url: `/expense-category`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateExpenseCategoriesById: builder.mutation({
      invalidatesTags: ["expense-categories"],
      query: ({ body, id }) => ({
        url: `/expense-category/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusExpenseCategoriesById: builder.mutation({
      invalidatesTags: ["expense-categories"],
      query: ({ body, id }) => ({
        url: `/expense-category/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllExpenseCategoriesDataQuery,
  useDeleteExpenseCategoriesByIdMutation,
  useAddExpenseCategoriesMutation,
  useGetExpenseCategoriesByIdQuery,
  useUpdateExpenseCategoriesByIdMutation,
  useGetAllExpenseCategoriesQuery,
  useChangeStatusExpenseCategoriesByIdMutation,
} = ExpenseCategoriesApi;
